import { createFileRoute } from '@tanstack/react-router';
import { WebshopSettingsTab } from '@/app/(client)/company-settings/-components/WebshopSettingsTab';
import { useSessionStore } from '@/store/sessionStore';

export const Route = createFileRoute(
  '/(client)/company-settings/(pages)/webshop-settings',
)({
  component: WebshopSettingsRoute,
});

function WebshopSettingsRoute() {
  const user = useSessionStore(s => s.user);
  const shopId = (user?.company as { shopId?: string } | undefined)?.shopId;
  return <WebshopSettingsTab shopId={shopId} />;
}
